import { render, staticRenderFns } from "./SemiPieChart.vue?vue&type=template&id=a3c456ac&scoped=true&"
import script from "./SemiPieChart.vue?vue&type=script&lang=js&"
export * from "./SemiPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c456ac",
  null
  
)

export default component.exports